<template>
  <v-row>
    <v-dialog
      v-bind:value="dialog"
      eager
      @click:outside="$emit('click-outside')"
      :persistent="persistent"
      :max-width="getMaxWidth"
      :overlay-color="overlayColor"
      :overlay-opacity="opacity"
    >
      <v-card>
        <v-card-title class="title justify-center">
          <span class="text-h5 dialog-title">
            <slot name="header">{{title | capitalize}}</slot>
          </span>
          <div class="close-actions">
            <slot name="header-actions"/>

            <v-btn icon data-test="close-button" @click="closeHandler">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <slot name="subHeader"></slot>
        <v-card-text>
          <v-container>
            <slot></slot>
          </v-container>
          <slot name="actions"></slot>
        </v-card-text>
        <!-- <v-card-actions> -->
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang='ts'>
/*
  Wrapping component to all dialogs in application.
  Created in order to harmonize the structure in the whole
  application.
  header  => Header of the dialog
  default => the main body of the dialog
  actions  => the 'footer' of the dialog
*/
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  filters: {
    capitalize: function(value: any) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
})
export default class DialogWrapper extends Vue {
  @Prop()
  private readonly title: string | undefined;
  /*
    Max width of the dialog popup in px
  */
  @Prop({ default: () => 600 })
  private readonly maxWidth!: number;

  @Prop({ default: () => 0.3 })
  private readonly opacity!: number;

  @Prop({ default: () => false })
  private readonly persistent: boolean | undefined;
  /*
    Boolean that set the state of the dialog (open/closed)
  */
  @Prop({ default: () => false })
  private readonly dialog: boolean | undefined;

  @Prop()
  private readonly overlayColor: string | undefined;

  private closeHandler() {
    this.$emit('close-dialog');
  }
  get getMaxWidth(): string {
    return `${this.maxWidth}`;
  }
}
</script>

<style lang='scss' scoped>
@import '@/main.scss';

.title {
  color: $blue-title;
}

.close-actions {
   position: absolute;
   right: 5px;
 }
</style>
